(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-comparison"] && !Shopify.designMode) return;
  try {
     (function(){ document.querySelectorAll('.ba-compare-section .ba').forEach(function(card){ var input = card.querySelector('.ba__range'); var handle = card.querySelector('.ba__handle'); var afterImg = card.querySelector('.ba__img--after'); var divider = card.querySelector('.ba__divider'); function setPos(p){ p = Math.max(0, Math.min(100, p)); card.style.setProperty('--pos', p + '%'); if(afterImg) afterImg.style.clipPath = 'inset(0 calc(100% - ' + p + '%) 0 0)'; if(divider) divider.style.left = p + '%'; if(handle) handle.style.left = p + '%'; if(input) input.value = p; } var start = parseInt(input && input.value ? input.value : '50', 10); setPos(start); function pointerToPercent(e){ var rect = card.getBoundingClientRect(); var clientX = e.clientX; if(clientX == null && e.touches && e.touches[0]) clientX = e.touches[0].clientX; var x = clientX - rect.left; return (x / rect.width) * 100; } function onMove(e){ setPos(pointerToPercent(e)); } function prevent(e){ e.preventDefault(); } if(input){ ['input','change'].forEach(function(ev){ input.addEventListener(ev, function(){ setPos(parseInt(this.value,10) || 50); }); }); } ['mousedown','touchstart'].forEach(function(ev){ card.addEventListener(ev, function(e){ prevent(e); onMove(e); dragging = true; }, {passive:false}); }); ['mousemove','touchmove'].forEach(function(ev){ document.addEventListener(ev, function(e){ if(dragging){ prevent(e); onMove(e); } }, {passive:false}); }); ['mouseup','touchend','touchcancel','mouseleave'].forEach(function(ev){ document.addEventListener(ev, function(){ dragging = false; }); }); var dragging = false; if(handle){ handle.setAttribute('tabindex','0'); handle.addEventListener('keydown', function(e){ var v = parseInt(input && input.value || 50, 10); if(e.key === 'ArrowLeft' || e.key === 'ArrowDown') setPos(v - 2); if(e.key === 'ArrowRight' || e.key === 'ArrowUp') setPos(v + 2); }); } }); })(); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["total-eye-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  const initializeTotalEyeSticky = (sticky) => {
    if (sticky.totalEyeObserver) {
      sticky.totalEyeObserver.disconnect();
    }

    const heroActions = document.querySelector('.te-hero .te-hero__actions');

    if (!heroActions) {
      sticky.classList.remove('is-hero-actions-visible');
      sticky.setAttribute('aria-hidden', 'false');
      return;
    }

    sticky.totalEyeObserver = new IntersectionObserver(([entry]) => {
      sticky.classList.toggle('is-hero-actions-visible', entry.isIntersecting);
      sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
    }, {
      threshold: 0.05
    });

    sticky.totalEyeObserver.observe(heroActions);
  };

  const initializeTotalEyeStickies = () => {
    document.querySelectorAll('.te-sticky').forEach(initializeTotalEyeSticky);
  };

  initializeTotalEyeStickies();
  document.addEventListener('shopify:section:load', initializeTotalEyeStickies);

  } catch(e) { console.error(e); }
})();
})();
